import { create } from 'zustand';

// 文件类型 Tab 配置
export const FILE_TABS = [
    { id: 'all', label: '全部' },
    { id: 'recent', label: '最近' },
    { id: 'video', label: '视频' },
    { id: 'image', label: '图片' },
    { id: 'document', label: '文档' },
] as const;

export type FileTabId = typeof FILE_TABS[number]['id'];

interface UIState {
    /** 当前激活的文件类型 Tab */
    activeFileTab: FileTabId;
    /** 设置当前激活的文件类型 Tab */
    setActiveFileTab: (tabId: FileTabId) => void;
}

/**
 * UI 全局状态管理
 * 用于管理跨组件的 UI 状态，如导航 Tab
 */
export const useUIStore = create<UIState>((set) => ({
    activeFileTab: 'all',
    setActiveFileTab: (tabId) => set({ activeFileTab: tabId }),
}));
